<div class="chart-wrapper">
  <svg
    viewBox="25 10 550 280"
    preserveAspectRatio="xMidYMid meet"
    class="periodontal-chart"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter id="grayFilter" color-interpolation-filters="sRGB">
        <feColorMatrix
          type="matrix"
          values="0.33 0.33 0.33 0 0.1  0.33 0.33 0.33 0 0.1  0.33 0.33 0.33 0 0.1  0 0 0 1 0"
        />
      </filter>
    </defs>

    @if (isJawService) {
    <!-- Upper Jaw Selection Area -->
    <rect
      x="5"
      y="5"
      width="590"
      height="140"
      rx="8"
      fill="transparent"
      [attr.stroke]="upperJawSelected ? selectionColor : 'var(--border)'"
      [attr.fill]="upperJawSelected ? selectionColor : 'transparent'"
      [attr.stroke-dasharray]="upperJawSelected ? 'none' : '4,4'"
      fill-opacity="0.05"
      stroke-width="1.5"
      class="jaw-selection-overlay"
      (click)="onJawClick('upper')"
      style="cursor: pointer"
    />

    <!-- Lower Jaw Selection Area -->
    <rect
      x="5"
      y="155"
      width="590"
      height="140"
      rx="8"
      fill="transparent"
      [attr.stroke]="lowerJawSelected ? selectionColor : 'var(--border)'"
      [attr.fill]="lowerJawSelected ? selectionColor : 'transparent'"
      [attr.stroke-dasharray]="lowerJawSelected ? 'none' : '4,4'"
      fill-opacity="0.05"
      stroke-width="1.5"
      class="jaw-selection-overlay"
      (click)="onJawClick('lower')"
      style="cursor: pointer"
    />
    }

    @if (showQuadrants) {
    <!-- Quadrant separator lines -->
    <line
      x1="290"
      y1="0"
      x2="290"
      y2="280"
      stroke="var(--text-muted)"
      stroke-width="2"
      stroke-dasharray="5,5"
      opacity="0.5"
    />
    <line
      x1="0"
      y1="150"
      x2="600"
      y2="150"
      stroke="var(--text-muted)"
      stroke-width="2"
      stroke-dasharray="5,5"
      opacity="0.5"
    />

    <!-- Quadrant Labels -->
    <text
      x="150"
      y="20"
      text-anchor="middle"
      font-size="6"
      font-weight="normal"
      fill="var(--text-muted)"
      class="quadrant-label"
    >
      {{ 'WORKORDER.DETAIL.QUADRANT_UPPER_RIGHT' | translate }}
    </text>
    <text
      x="450"
      y="20"
      text-anchor="middle"
      font-size="6"
      font-weight="normal"
      fill="var(--text-muted)"
      class="quadrant-label"
    >
      {{ 'WORKORDER.DETAIL.QUADRANT_UPPER_LEFT' | translate }}
    </text>
    <text
      x="450"
      y="285"
      text-anchor="middle"
      font-size="6"
      font-weight="normal"
      fill="var(--text-muted)"
      class="quadrant-label"
    >
      {{ 'WORKORDER.DETAIL.QUADRANT_LOWER_LEFT' | translate }}
    </text>
    <text
      x="150"
      y="285"
      text-anchor="middle"
      font-size="6"
      font-weight="normal"
      fill="var(--text-muted)"
      class="quadrant-label"
    >
      {{ 'WORKORDER.DETAIL.QUADRANT_LOWER_RIGHT' | translate }}
    </text>
    }

    <!-- Upper Teeth -->
    @for (tooth of upperTeeth(); track tooth.id) {
    <g
      class="tooth-group upper-tooth"
      [attr.data-tooth-id]="tooth.id"
      [class.selected]="isToothSelected(tooth.id)"
      [class.has-color]="toothColors.has(tooth.id)"
      [style.--selection-color]="getToothColor(tooth.id)"
      (click)="onToothClick(tooth.id)"
    >
      <rect
        [attr.x]="tooth.x - 14"
        [attr.y]="tooth.y - 55"
        width="28"
        height="85"
        fill="transparent"
        class="tooth-hitbox"
      />
      <image
        [attr.href]="'assets/tooth-svg/' + tooth.id + '.svg'"
        [attr.x]="tooth.x - 35"
        [attr.y]="tooth.y - 50"
        width="70"
        height="100"
        [class.selected]="isToothSelected(tooth.id) || toothColors.has(tooth.id)"
        class="tooth-image"
        pointer-events="none"
      />
      @if (showNumbers) {
      <text
        [attr.x]="tooth.x"
        [attr.y]="tooth.y - 55"
        text-anchor="middle"
        font-size="7"
        font-weight="normal"
        [attr.fill]="(isToothSelected(tooth.id) || toothColors.has(tooth.id)) ? getToothColor(tooth.id) : 'var(--text-muted)'"
        class="tooth-number"
        pointer-events="none"
      >
        {{ tooth.id }}
      </text>
      }
    </g>
    }

    <!-- Lower Teeth -->
    @for (tooth of lowerTeeth(); track tooth.id) {
    <g
      class="tooth-group lower-tooth"
      [attr.data-tooth-id]="tooth.id"
      [class.selected]="isToothSelected(tooth.id)"
      [class.has-color]="toothColors.has(tooth.id)"
      [style.--selection-color]="getToothColor(tooth.id)"
      (click)="onToothClick(tooth.id)"
    >
      <rect
        [attr.x]="tooth.x - 14"
        [attr.y]="tooth.y - 30"
        width="28"
        height="130"
        fill="transparent"
        class="tooth-hitbox"
      />
      <image
        [attr.href]="'assets/tooth-svg/' + tooth.id + '.svg'"
        [attr.x]="tooth.x - 35"
        [attr.y]="tooth.y - 50"
        width="70"
        height="100"
        [class.selected]="isToothSelected(tooth.id) || toothColors.has(tooth.id)"
        class="tooth-image"
        pointer-events="none"
      />
      @if (showNumbers) {
      <text
        [attr.x]="tooth.x"
        [attr.y]="tooth.y + 60"
        text-anchor="middle"
        font-size="7"
        font-weight="normal"
        [attr.fill]="(isToothSelected(tooth.id) || toothColors.has(tooth.id)) ? getToothColor(tooth.id) : 'var(--text-muted)'"
        class="tooth-number"
        pointer-events="none"
      >
        {{ tooth.id }}
      </text>
      }
    </g>
    }
  </svg>
</div>
